import { render } from "./ArticleCard.vue?vue&type=template&id=ac127b2c&ts=true"
import script from "./ArticleCard.vue?vue&type=script&lang=ts"
export * from "./ArticleCard.vue?vue&type=script&lang=ts"

import "./ArticleCard.vue?vue&type=style&index=0&id=ac127b2c&lang=scss"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__